import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import "@ckeditor/ckeditor5-build-classic/build/translations/zh";

export default {
  data() {
    return {
      priceKid: [{
        name: "定價",
        field: "base"
      }, {
        name: "售價",
        field: "sell"
      }, {
        name: "成本",
        field: "cost"
      } ],
      options: [{
          value: null,
          text: "請選擇分類"
        },
        {
          value: "a",
          text: "現場課程"
        },
        {
          value: "b",
          text: "線上課程"
        },
        {
          value: "c",
          text: "書籍商品"
        }
      ]
    };
  },
  computed: {
    thdata() {
      return this.data[this.pagename];
    }
  },
  methods: {
    changeinput(name, value, node = "") {
      if (node) {
        this.thdata[node][name] = value;
      } else {
        this.thdata[name] = value;
      }
    },
  },
  props: {
    data: Object,
    pagename: String
  }
};
